const numericValue = value => {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const priceDiscountPercent = (price, discountedPrice) => {
  const original = numericValue(price);
  const current = numericValue(discountedPrice);
  if (original == null || current == null || original <= 0 || current < 0 || current >= original) return null;
  return ((original - current) / original) * 100;
};

export const discountPercentLabel = percent => {
  const value = numericValue(percent);
  if (value == null || value <= 0 || value > 100) return null;
  const rounded = Math.round(value);
  if (rounded === 0) return '<1';
  if (rounded === 100 && value < 100) return '>99';
  return String(rounded);
};

export const discountSource = ({ price, discountedPrice, personalDiscount, productDiscount } = {}) => {
  const validPercent = value => {
    const number = numericValue(value);
    return number != null && number > 0 && number <= 100 ? number : 0;
  };
  const personal = validPercent(personalDiscount);
  const promotional = validPercent(productDiscount);
  const source = personal > 0 && personal >= promotional ? 'personal' : promotional > 0 ? 'product' : 'unknown';
  if (source === 'unknown') return source;

  const original = numericValue(price);
  const current = numericValue(discountedPrice);
  if (original != null && current != null) {
    // A manual or historical price may no longer match the catalog discount.
    const percent = source === 'personal' ? personal : promotional;
    if (priceDiscountPercent(original, current) == null || Math.ceil(original * (100 - percent) / 100) !== current) return 'unknown';
  }
  return source;
};

export const discountBadgeClass = product => discountSource(product) === 'product' ? 'badge-danger' : 'badge-dark';
